<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M6.972 20.08l2.633-16.9a.605.605 0 011.13-.193l2.83 5.304-6.593 11.79zm18.694 4.102L23.161 8.627a.606.606 0 00-1.023-.327L6.333 24.182l8.745 4.92c.55.308 1.218.308 1.768 0l8.82-4.92zM18.56 10.608l-2.026-3.869a.604.604 0 00-1.069 0L6.572 22.65 18.56 10.608z"/></svg>
</template>

<script>
export default {
  name: 'brandFirebaseFilled'
}
</script>
